import { fabric } from 'fabric'

// Reference: https://codesandbox.io/p/sandbox/fabric-js-image-crop-fill-feature-qpiq21?file=%2Fsrc%2Ffabric.CustomImage.js%3A185%2C5-185%2C25
export const TemplateImage = fabric.util.createClass(fabric.Group, {
    type: 'template-image',

    initialize: function (element, options, callback) {
        options || (options = {})
        this.callSuper('initialize', [], options)
        this.set('name', options.name || undefined) // Should probably throw an error here.

        this._initImage(element)
    },

    _initImage: function (element) {
        this.image = new fabric.Image(element, {
            originX: 'center',
            originY: 'center',
        })
        this.add(this.image)
    },

    setSrc: function (src, callback, options) {
        // NOTE: Needs tweaking. The image doesn't fill as expected when loaded in.
        this.image.setSrc(
            src,
            (oImg, isError) => {
                var scale = 200 / oImg.width
                this.image.set({ scaleX: scale, scaleY: scale })
                callback(this.image, isError)
            },
            options
        )
        return this
    },

    getSrc: function () {
        return this.image.getSrc()
    },

    render: function (ctx) {
        this.width *= this.scaleX
        this.height *= this.scaleY
        this.scaleX = 1
        this.scaleY = 1
        this.updateImageFill()
        this.callSuper('render', ctx)
    },

    updateImageFill: function () {
        this.scaleImage()
        this.applyClipPath()
    },

    scaleImage: function () {
        let boundaryHeight = this.height
        let boundaryWidth = this.width
        if (
            boundaryHeight / boundaryWidth >=
            this.image.height / this.image.width
        ) {
            this.image.scaleToHeight(boundaryHeight)
        } else {
            this.image.scaleToWidth(boundaryWidth)
        }
    },

    applyClipPath: function () {
        this.clipPath = new fabric.Rect({
            width: this.width,
            height: this.height,
            originX: 'center',
            originY: 'center',
        })
    },

    toString: function () {
        return this.callSuper('toString') + ' (name: ' + this.get('name') + ')'
    },

    toObject: function () {
        return fabric.util.object.extend(this.callSuper('toObject'), {
            name: this.get('name'),
        })
    },
})

fabric.TemplateImage = TemplateImage
fabric.TemplateImage.fromObject = function (object, callback) {
    var objects = object.objects,
        objOptions = fabric.util.object.clone(object, true)
    delete objOptions.objects

    fabric.util.enlivenObjects(objects, function (enlivenedObjects) {
        var options = fabric.util.object.clone(object, true)
        delete options.objects
        // NOTE: This enlivens the clip path
        fabric.util.enlivenObjectEnlivables(object, options, function () {
            // NOTE: since we're only ever loading one image into this "group" object, we can just the
            // load the 0th element into a new instance
            console.log(enlivenedObjects)
            callback &&
                callback(
                    new TemplateImage(enlivenedObjects[0]?._element, options)
                )
        })
    })
}

fabric.TemplateImage.fromURL = function (url, callback, imgOptions) {
    /* NOTE: this should be configurable via options (see below) to avoid potential issues..
     *
     * fabric.util.loadImage(url, function(img, isError) {
     * callback && callback(new TemplateImage(img, imgOptions), isError);
     * }, null, imgOptions && imgOptions.crossOrigin);
     *
     * */

    fabric.util.loadImage(
        url,
        function (img, isError) {
            callback && callback(new TemplateImage(img, imgOptions), isError)
        },
        null,
        'Anonymous'
    )
}
